import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardHeader,
  CardBody,
  Button,
  Row,
  Col,
  ModalFooter,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  fetchAvailableProgramLicenses,
  fetchCustomerProgrammeLicenses,
} from "../../actions/programLicenseActions";
import { connect } from "react-redux";
import moment from "moment";

import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import ExpiringLicense from "../ProgramLicense/ExpiringLicense";

class AddProgramLicenseToSchoolModal extends React.Component {
  state = {
    selectedLicenseToAdd: "",
    fortNoxNbrPrgLic: "",
    fortNoxNbrStudLic: "",
    fortNoxCostCenter: "",
    validTo: "",
    updateLicense: null,
    animate: "",
    isUpdated: false,
    popoverOpen: false,
  };

  handleChange = (selected) => {
    this.setState({
      selectedLicenseToAdd: selected.licenseName,
      fortNoxNbrPrgLic: selected.fortNoxProgramLicenseNumber,
      fortNoxNbrStudLic: selected.fortNoxStudentProgramLicenseNumber,
      fortNoxCostCenter: selected.fortNoxCostCenter,
    });
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  togglePopover = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  };

  addProgramLicenseToSchool = (school) => {
    if (!this.state.updateLicense) {
      axios
        .post(
          `${API_BASE_URL}/ProgramLicense?name=${
            this.state.selectedLicenseToAdd
          }&customerId=${school.id}
        &fortNoxNumber=${this.state.fortNoxNbrPrgLic.trim()}&fortNoxNumberStudent=${this.state.fortNoxNbrStudLic.trim()}&fortNoxCostCenter=${this.state.fortNoxCostCenter.trim()}`
        )
        .then((response) => {
          toast.success(
            "Programlicensen har lagts till skolan",
            this.toastOptions
          );

          this.props.customerLicenses.result.push(response.data.result);
          this.setState({ isUpdated: true });
        })
        .catch((err) => {
          toast.warn(
            err && err.response && err.response.data
              ? err.response.data
              : "Det gick inte att lägga till programlicensen till skolan",
            this.toastOptions
          );
        });
    }

    if (this.state.updateLicense) {
      axios
        .put(
          `${API_BASE_URL}/ProgramLicense/UpdateProgramLicense?licenseId=${
            this.state.updateLicense.id
          }&fortNoxNumberProgramLicense=${this.state.fortNoxNbrPrgLic.trim()}&fortNoxNumberStudentLicense=${this.state.fortNoxNbrStudLic.trim()}&fortNoxCostCenter=${
            this.state.fortNoxCostCenter
          }&validTo=${this.state.validTo}`
        )
        .then(() => {
          toast.success("Programlicensen är uppdaterad", this.toastOptions);

          const index = this.props.customerLicenses.result.findIndex(
            (item) => item.id === this.state.updateLicense.id
          );

          this.props.customerLicenses.result[index].fortNoxCostCenter =
            this.state.fortNoxCostCenter;
          this.props.customerLicenses.result[index].fortNoxNumber =
            this.state.fortNoxNbrPrgLic;
          this.props.customerLicenses.result[index].validTo =
            this.state.validTo;

          this.setState({ isUpdated: true });
        })
        .catch((err) => {
          toast.warn(
            err && err.response && err.response.data
              ? err.response.data
              : "Det gick inte att uppdatera programlicensen",
            this.toastOptions
          );
        });
    }

    this.setState({ isUpdated: false });
  };

  componentDidMount() {
    this.props.dispatch(fetchAvailableProgramLicenses());

    if (this.props.school)
      this.props.dispatch(fetchCustomerProgrammeLicenses(this.props.school.id));
  }

  updateLicense = (license) => {
    this.setState({
      updateLicense: license,
      selectedLicenseToAdd: license.id,
      fortNoxNbrPrgLic: license.fortKnoxNumber,
      fortNoxNbrStudLic: license.fortKnoxNumberStudentPackage,
      fortNoxCostCenter: license.fortKnoxCostCenter,
      validTo: license.validTo,
      animate: "animated slideInUp",
    });
  };
  quitEditing = () => {
    this.setState({
      animate: "animated flipInY",
      updateLicense: null,
      fortNoxNbrPrgLic: null,
      fortNoxNbrStudLic: null,
      fortNoxCostCenter: null,
    });
  };
  render() {
    if (
      this.props.programLicenses.loading ||
      this.props.customerLicenses.loading
    ) {
      return <div></div>;
    }

    //Alla license
    var allLicenses = this.props.programLicenses.result;

    let schoolLicenses = this.props.customerLicenses.result;

    let availableLicenses = [];

    let school = this.props.school;

    if (schoolLicenses !== null) {
      allLicenses.forEach((item) => {
        if (schoolLicenses.filter((x) => x.name === item).length === 0)
          availableLicenses.push(item);
      });
    }

    return (
      <Modal
        size="xl"
        isOpen={this.props.isOpen}
        toggle={() => this.props.toggle(false, null, null)}
      >
        <ModalHeader toggle={() => this.props.toggle(false, null, null)}>
          Programlicenser - {school !== null ? school.name : ""}
        </ModalHeader>
        <ModalBody>
          <Card
            className={
              this.state.animate +
              " " +
              (this.state.updateLicense ? "bg-light" : "")
            }
            style={{ zIndex: 9999 }}
          >
            <CardHeader>
              <Row className="m-0 p-0">
                <Col lg="10">
                  <div className={this.state.updateLicense ? "d-none" : ""}>
                    <FontAwesomeIcon icon="plus-circle" />
                    &nbsp;Lägg till programlicens
                  </div>
                  <div className={this.state.updateLicense ? "" : "d-none"}>
                    <FontAwesomeIcon icon="pen-square" />
                    &nbsp;Uppdatera{" "}
                    {this.state.updateLicense
                      ? this.state.updateLicense.name
                      : ""}
                  </div>
                </Col>
                <Col lg="2">
                  <Button
                    id="helpBtn"
                    color="link"
                    className="float-end"
                    title="Klicka för att läsa hjälpen"
                    onClick={this.togglePopover}
                  >
                    <FontAwesomeIcon
                      icon="question-circle"
                      className="text-info"
                    />
                  </Button>

                  <Popover
                    placement="bottom"
                    isOpen={this.state.popoverOpen}
                    target={"helpBtn"}
                  >
                    <PopoverHeader>Hjälp - Programlicens</PopoverHeader>
                    <PopoverBody>
                      <strong>Skapa ny programlicens till skolan</strong>
                      <br />
                      1. Välj vilken programlicens som skolan ska ha i listan:
                      "Välj programlicens"
                      <br />
                      2. Klicka på knappen "Lägg till" - Klart!
                      <br />
                      (Giltig t.o.m kommer att vara dagens datum + 1 år)
                      <br />
                      <br />
                      <strong>Uppdatera en befintlig programlicens</strong>
                      <br />
                      1. Klicka på programlicensnamnet
                      <br />
                      2. Ändra de värden som behövs ändras
                      <br />
                      3. Klicka på knappen "Uppdatera"
                    </PopoverBody>
                  </Popover>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form>
                <FormGroup>
                  <Select
                    placeholder="Välj programlicens"
                    className={this.state.updateLicense ? "d-none" : ""}
                    noOptionsMessage={() =>
                      "Skolan har redan alla tillgängliga programlicenser"
                    }
                    onChange={(selected) => this.handleChange(selected)}
                    options={availableLicenses.map((option) => ({
                      ...option,
                      label: option.licenseName,
                      value: option.licenseName,
                      clearableValue: true,
                    }))}
                  />
                </FormGroup>
                <FormGroup>
                  <Row className="m-0 p-0">
                    <Col lg="6">
                      <Label for="fortNoxNbrPrgLic">Artikelnr prg lic</Label>
                      <Input
                        readOnly="true"
                        type="text"
                        name="fortNoxNbrPrgLic"
                        id="fortNoxNbrPrgLic"
                        placeholder="Artikelnr prg lic fortnox"
                        onChange={(event) => this.handleInputChange(event)}
                        defaultValue={
                          this.state.updateLicense
                            ? this.state.updateLicense.fortKnoxNumber
                            : this.state.fortNoxNbrPrgLic
                        }
                      />
                    </Col>
                    <Col lg="6">
                      <Label for="fortNoxNbrStudLic">Artikelnr elev lic</Label>
                      <Input
                        readOnly="true"
                        type="text"
                        name="fortNoxNbrStudLic"
                        id="fortNoxNbrStudLic"
                        placeholder="Artikelnr elev lic fortnox"
                        onChange={(event) => this.handleInputChange(event)}
                        defaultValue={
                          this.state.updateLicense
                            ? this.state.updateLicense
                                .fortKnoxNumberStudentPackage
                            : this.state.fortNoxNbrStudLic
                        }
                      />
                    </Col>
                    <Col lg="6">
                      <Label for="costCenter">Kostnadst.</Label>
                      <Input
                        readOnly="true"
                        type="text"
                        name="fortNoxCostCenter"
                        id="fortNoxCostCenter"
                        placeholder="Kostnadställe fortnox"
                        onChange={(event) => this.handleInputChange(event)}
                        defaultValue={
                          this.state.updateLicense
                            ? this.state.updateLicense.fortKnoxCostCenter
                            : this.state.fortNoxCostCenter
                        }
                      />
                    </Col>
                    <Col
                      lg="6"
                      className={this.state.updateLicense ? "" : "d-none"}
                    >
                      <Label for="exampleDate">Giltig t.o.m</Label>
                      <Input
                        type="date"
                        name="validTo"
                        id="validTo"
                        placeholder="Programlicensen är giltig t.o.m"
                        onChange={(event) => this.handleInputChange(event)}
                        key={
                          this.state.updateLicense
                            ? moment(this.state.updateLicense.validTo).format(
                                "YYYY-MM-DD"
                              )
                            : null
                        }
                        defaultValue={
                          this.state.updateLicense
                            ? moment(this.state.updateLicense.validTo).format(
                                "YYYY-MM-DD"
                              )
                            : null
                        }
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Form>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  outline
                  className={this.state.updateLicense ? "" : "d-none"}
                  onClick={this.quitEditing}
                >
                  Avbryt
                </Button>
                <Button
                  outline
                  color="success"
                  className="float-end"
                  disabled={this.state.selectedLicenseToAdd.length === 0}
                  onClick={() => this.addProgramLicenseToSchool(school)}
                >
                  {this.state.updateLicense ? "Uppdatera" : "Lägg till"}
                </Button>
              </div>
            </CardBody>
          </Card>

          <Card body>
            <Row>
              <Col lg="12" className="h5">
                {school !== null ? school.name : ""} programlicenser
              </Col>
            </Row>
            <Row className="mb-1 mt-2">
              <Col lg="5" className="font-weight-bold">
                Programlicens
              </Col>
              <Col lg="2" className="font-weight-bold">
                Fortnox art.
              </Col>
              <Col lg="3" className="font-weight-bold">
                Fortnox art. elev
              </Col>
              <Col lg="2" className="font-weight-bold">
                Giltig t.o.m
              </Col>
            </Row>
            {schoolLicenses &&
              schoolLicenses.map((license, index) => {
                let expiringLicenses = [];
                expiringLicenses.push(license);
                return (
                  <Row key={index}>
                    <Col lg="5">
                      <Button
                        color="link"
                        title="Klicka för att ändra denna programlicens"
                        className="p-0 m-0"
                        onClick={() => this.updateLicense(license)}
                      >
                        {license.name}
                      </Button>
                    </Col>
                    <Col lg="2">{license.fortKnoxNumber}</Col>
                    <Col lg="3">{license.fortKnoxNumberStudentPackage}</Col>
                    <Col lg="2">
                      {moment(license.validTo).format("YYYY-MM-DD")}
                      <ExpiringLicense
                        key={license.id}
                        licenses={expiringLicenses}
                      />
                    </Col>
                  </Row>
                );
              })}
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            outline
            onClick={() => this.props.toggle(false, null, null)}
          >
            Stäng
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    programLicenses: store.programLicenseReducer,
    customerLicenses: store.programLicenseByCustomerReducer,
  };
};

export default connect(mapStateToProps)(AddProgramLicenseToSchoolModal);
